/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRefetchContainer_itemSearch$ref = any;
export type SbSharedRefetchContainer_itemSearch = {
    readonly pageType: string | null;
    readonly vanityUriRef: string | null;
    readonly displayUriRef: string | null;
    readonly searchCorrections: {
        readonly semanticSearchTerm: string | null;
    } | null;
    readonly " $refType": SbSharedRefetchContainer_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefetchContainer_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pageType",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "vanityUriRef",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayUriRef",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchCorrections",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchCorrectionsType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "semanticSearchTerm",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'a6f6c3542d5ac1b2fcea0eab613c694f';
export default node;
